import { 
    saveUser, 
    getUser, 
    getUsers,
    // getUsersTop, 
    getUsersSorted,
    findUser,
    updateUser, 
    deleteUser,
    loginUser, 
    createUser, 
    getMe,
    verifyEmail,
    verifyUser,
    changePassword,
    resetPassword,
    doResetPassword,
    lookupUsername,
    getUserResources,
    getUserFavorites,
    updateUserProfile } from '@/api/run'
import { 
    SET_USER_LOADING,
    SET_USERS,
    SET_USERS_SORTED,
    SET_USER,
    SET_USER_RESOURCES,
    SET_USER_FAVORITES,
    SET_USER_ID,
    SET_CURRENT_USER,
    TOGGLE_DIALOG_LOGIN,
    TOGGLE_DIALOG_PASSWORD,
    TOGGLE_DIALOG_DELETE_USER,
    SET_USER_ERROR,
    CLEAR_USER_ERROR
} from './mutation-types'
import {
    GET_USERS,
    GET_USERS_SORTED,
    SAVE_USER,
    SAVE_USER_PROFILE,
    GET_USER,
    FIND_USER,
    GET_USER_RESOURCES,
    GET_USER_FAVORITES,
    CREATE_USER,
    UPDATE_USER,
    LOGIN_USER,
    LOGOUT_USER,
    GET_ME,
    VERIFY_EMAIL,
    VERIFY_USER,
    CHANGE_PASSWORD,
    RESET_PASSWORD,
    DO_PASSWORD_RESET,
    LOOKUP_USERNAME,
    DELETE_USER
} from './action-types'

export default {
    state: {
        isLoading: false,
        dialogLogin: false,
        dialogManagePassword: false,
        dialogUserDelete: false,
        error: null,
        info: null,
        all: [],
        sorted: [],
        
        /* logged in user */
        currentUser: {},
        token: localStorage.getItem('token'),
        
        /* user selected or edited */
        user: {
            objectId: null,
            username: ''
        },
        userPlys: [],
        userPrivatePlys: [],
        userFavorites: [],
        userProfile: {}
    },
    getters : {
        isLoggedIn: state => state.token,
        username: state => state.currentUser.username,
        avatarImg: state => state.currentUser.avatar ? state.currentUser.avatar:'https://ui-avatars.com/api/?size=48&name=' + state.currentUser.username + '',
        email: state => state.currentUser.email,
        usersWithAvatars: state => { return state.sorted.filter(u=>u.emailVerified===true).slice(0,8) }
    },
    mutations: {
        [SET_USER_LOADING] (state, isLoading) {
            state.isLoading = isLoading
        },
        [SET_USERS] (state, all) {
            state.all = all
        },
        [SET_USERS_SORTED] (state, users) {
            state.sorted = users
        },
        [SET_USER] (state, user) {
            state.user = user
        },
        [SET_USER_RESOURCES] (state, plys) {
            //console.log('SET_USER_PLYS', plys)
            state.userPlys = plys
        },
        [SET_USER_FAVORITES] (state, plys) {
            //console.log('SET_USER_PLYS', plys)
            state.userFavorites = plys
        },
        [SET_USER_ID] (state, id) {
            //console.log('SET_USER_ID', id)
            state.user.objectId = id
        },
        [SET_CURRENT_USER] (state, user) {
            state.currentUser = user
            state.token = user.sessionToken
            localStorage.setItem('token', user.sessionToken)
        },
        [TOGGLE_DIALOG_LOGIN] (state, bool) {
            //console.log('TOGGLE_DIALOG_LOGIN', bool)
            state.dialogLogin = bool
        },
        [TOGGLE_DIALOG_PASSWORD] (state, bool) {
            state.dialogManagePassword = bool
        },
        [TOGGLE_DIALOG_DELETE_USER] (state, bool) {
            state.dialogUserDelete = bool
        },
        [SET_USER_ERROR] (state, resp) {
            state.error = resp
            setTimeout(()=>{
                state.error = null
            }, 8000)
        },
        [CLEAR_USER_ERROR] (state) {
            state.error = null
        }
    },
    actions: {
        [GET_USERS]: async ({commit}) => {
            commit(SET_USER_LOADING, true)
            try {
                let resp = await getUsers()
                commit(SET_USERS, resp)
            }
            finally {
                commit(SET_USER_LOADING, false)
            }
        },
        [GET_USERS_SORTED]: async ({commit}, sortBy) => {
            let resp = await getUsersSorted(sortBy)
            commit(SET_USERS_SORTED, resp)
        },
        [GET_USER]: async ({commit}, id) => {
            //console.log('dispatched GET_USER', id)
            let resp = await getUser(id)
            commit(SET_USER, resp)
        },
        [FIND_USER]: async ({commit}, username) => {
            //console.log('dispatched FIND_USER', username)
            commit(SET_USER_LOADING, true)
            let resp = await findUser(username)
            if (resp && resp.length === 1) {
                if (resp[0].markDeleted) {
                    commit('SET_ERROR', 'This user has been removed')
                }
                commit(SET_USER, resp[0])
            }
            else {
                commit(SET_USER, {
                    objectId: null,
                    username: ''
                })
                commit('SET_ERROR', 'User not found')
            }
            commit(SET_USER_LOADING, false)
        },
        [GET_USER_RESOURCES]: async ({commit}, userId) => {
            commit(SET_USER_LOADING, true)
            try {
                let resp = await getUserResources(userId)
                commit(SET_USER_RESOURCES, resp)
            }
            finally {
                commit(SET_USER_LOADING, false)
            }
        },
        [GET_USER_FAVORITES]: async ({commit}, userId) => {
            commit(SET_USER_LOADING, true)
            try {
                let resp = await getUserFavorites(userId)
                commit(SET_USER_FAVORITES, resp)
            }
            finally {
                commit(SET_USER_LOADING, false)
            }
        },
        [SAVE_USER]: async ({state, commit}) => {
            //console.log('dispatched SAVE_USER', state.user)
            let resp = await saveUser(state.user)
            commit(SET_USER_ID, resp.objectId)
        },
        [SAVE_USER_PROFILE]: async ({state}, { profileId, profile }) => {
            //console.log('dispatched SAVE_USER_PROFILE', state.user)
            let resp = await updateUserProfile(profileId, profile)
            state.userProfile = resp
        },
        [UPDATE_USER]: async ({commit}, payload) => {
            //console.log('dispatched UPDATE_USER', payload)
            let resp = await updateUser(payload)
            //console.log(resp)
            commit(SET_USER_ID, resp.objectId)
        },
        [LOGIN_USER]: async ({commit}, {username, password}) => {
            //console.log('dispatched LOGIN_USER', username)
            commit(SET_USER_LOADING, true)
            let resp = await loginUser(username, password)
            if (resp && resp.sessionToken) {
                commit(SET_CURRENT_USER, resp)
                commit(TOGGLE_DIALOG_LOGIN, false)
                commit('SET_INFO', "Hello " + username + '!')
            }
            else if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit(LOGOUT_USER)
                commit(TOGGLE_DIALOG_LOGIN, false)
            }
            commit(SET_USER_LOADING, false)
        },
        [LOGOUT_USER] ({state, commit}) {
            //console.log('LOGOUT_USER')
            state.currentUser = {}
            state.token = null
            localStorage.removeItem('token')
            commit('SET_INFO', "Goodbye for now!")
        },
        [GET_ME]: async ({commit}, token) => {
            //console.log('dispatched GET_ME', token)
            let resp = await getMe(token)
            if (resp && resp.sessionToken) {
                commit(SET_CURRENT_USER, resp)
            }
            else if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
                commit(TOGGLE_DIALOG_LOGIN, true)
            }
            else {
                commit(TOGGLE_DIALOG_LOGIN, true)
            }
        },
        [CREATE_USER]: async ({commit}, newUser) => {
            //console.log('dispatched CREATE_USER', newUser.username)
            let resp = await createUser(newUser)
            if (resp && resp.sessionToken) {
                commit(SET_CURRENT_USER, resp)
                commit('SET_INFO', "User account created. Please verify your email.")
            }
            else if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit(LOGOUT_USER)
            }
        },
        [VERIFY_EMAIL]: async ({commit}, payload) => {
            // this sends the user a link for them to click
            //console.log('dispatched VERIFY_EMAIL', payload)
            let resp = await verifyEmail(payload)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', "Verification email was sent")
            }
        },
        [VERIFY_USER]: async ({commit,state}, payload) => {
            // this uses the link that was sent to verify the user
            //console.log('dispatched VERIFY_USER', payload)
            let resp = await verifyUser(payload)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
                state.currentUser.emailVerified = false
            }
            else {
                state.currentUser.emailVerified = true
                commit('SET_INFO', "Thanks, your email was verified")
            }
        },
        [CHANGE_PASSWORD]: async ({commit}, payload) => {
            //console.log('dispatched CHANGE_PASSWORD', payload)
            let resp = await changePassword(payload)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', "Password change successful")
            }
        },
        [RESET_PASSWORD]: async ({commit}, payload) => {
            //console.log('dispatched RESET_PASSWORD', payload)
            let resp = await resetPassword(payload)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', "Password reset email will be sent")
            }
        },
        [DO_PASSWORD_RESET]: async ({commit}, payload) => {
            //console.log('dispatched DO_PASSWORD_RESET', username)
            let resp = await doResetPassword(payload)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', resp)
            }
        },
        [LOOKUP_USERNAME]: async ({commit}, email) => {
            //console.log('dispatched LOOKUP_USERNAME', email)
            let resp = await lookupUsername(email)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', "Username reminder sent to " + email)
            }
        },
        [DELETE_USER]: async ({commit}, user) => {
            let resp = await deleteUser(user)
            if (resp && resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', "User account deleted. We're sorry to see you go!")
            }
        }
    }
}